/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-16 15:59:09
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-07-04 09:31:30
 * @FilePath: \vue-hepha-order\src\views\setting\queryConfig\SettingForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const DealerGoalQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'saleGoal.country', // 国家
            key:'country',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'saleGoal.country',
            optionToLocale:true,
            options:[]
        },
        {
            // name:'saleGoal.countryCode', // 国家编码
            key:'country_code',
            type:'select',
            width:'200px',
            allowClear:true,
            optionToLocale:true,
            placeholder:'saleGoal.countryCode',
            options:[]
        },
        {
            // name:'saleGoal.year', // 年
            key:'year',
            type:'select',   
            allowClear:false,
            optionToLocale:true,
            width:'200px',
            placeholder:'saleGoal.year',
            options:[
                {
                    label:'2024',
                    value:'2024'
                },
                {
                    label:'2025',
                    value:'2025'
                },
                {
                    label:'2026',
                    value:'2026'
                },
            ]
        },
    ]
}

const AddDealerGoalForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        {
            name:'saleGoal.year', // 年
            key:'year',
            type:'select',   
            allowClear:true,
            optionToLocale:true,
            required: true,
            width:'300px',
            placeholder:'',
            options:[]
        },
        {
            name:'saleGoal.country', // 国家
            key:'country',
            type:'select',
            width:'300px',
            placeholder:'',
            allowClear:true,
            required: true,
            optionToLocale:true,
            options:[]
        },
        {
            name:'saleGoal.countryCode', // 国家编码
            key:'country_code',
            type:'input',
            width:'300px',
            allowClear:true,
            required: true,
            placeholder:'',
            disabled:true,
        },
        {
            name:'saleGoal.goalSaleNumber', // 目标销量
            key:'goal',
            type:'inputNumber',
            width:'300px',
            min:1,
            max:9999,
            precision:0,
            hideButton:true,
            required: true,
        },
    ]
}

const SaleGoalQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'saleGoal.year', // 年
            key:'year',
            type:'select',   
            allowClear:false,
            optionToLocale:true,
            width:'300px',
            placeholder:'base.select',
            options:[
                {
                    label:'2024',
                    value:'2024'
                },
                {
                    label:'2025',
                    value:'2025'
                },
                {
                    label:'2026',
                    value:'2026'
                },
            ]
        },
        // {
        //     name:'saleGoal.orderChannelType', // 订单渠道类型
        //     key:'order_channel_type',
        //     type:'select',
        //     width:'300px',
        //     allowClear:true,
        //     placeholder:'base.select',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'saleGoal.b2c',
        //             value:'0'
        //         },
        //         {
        //             label:'saleGoal.b2b',
        //             value:'1'
        //         }
        //     ]
        // },
        // {
        //     name:'saleGoal.productModelYear', // 车型
        //     key:'product_model_year',
        //     type:'select',
        //     allowClear:true,
        //     width:'300px',
        //     placeholder:'base.select',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'saleGoal.all',
        //             value:'ALL'
        //         },
        //         {
        //             label:'saleGoal.my23',
        //             value:'MY23'
        //         },
        //         {
        //             label:'saleGoal.my24',
        //             value:'MY24'
        //         },
        //     ]
        // },
    ]
}

const AddSaleGoalForm = {
    layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    formData:{},
    formField:[
        {
            name:'saleGoal.year', // 年
            key:'year',
            type:'select',
            optionToLocale:true,
            required: true, 
            width:'300px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'saleGoal.orderChannelType', // 订单渠道类型
            key:'order_channel_type',
            type:'select',
            width:'300px',
            required: true,
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'saleGoal.b2c',
                    value:0
                },
                {
                    label:'saleGoal.b2b',
                    value:1
                },
                {
                    label:'saleGoal.c2c',
                    value:5
                }
            ]
        },
        {
            name:'saleGoal.goalType', // 目标类型
            key:'goal_type',
            type:'select',
            required: true,
            width:'300px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'saleGoal.sales',
                    value:1
                },
            ]
        },
        {
            name:'saleGoal.productType', // 产品类型
            key:'product_type',
            type:'select',
            required: true,
            width:'300px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label:'saleGoal.bike',
                    value:'BIKE'
                },
            ]
        },
        // {
        //     name:'saleGoal.productModelYear', // 车型
        //     key:'product_model_year',
        //     type:'select',
        //     allowClear:true,
        //     required: true,
        //     width:'300px',
        //     placeholder:'base.select',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'saleGoal.all',
        //             value:'ALL'
        //         },
        //         {
        //             label:'saleGoal.my23',
        //             value:'MY23'
        //         },
        //         {
        //             label:'saleGoal.my24',
        //             value:'MY24'
        //         },
        //     ]
        // },
    ]
}

const AddSaleGoalForm2 = {
    layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    formData:{},
    formField:[
        {
            name:'saleGoal.Jan', // 一月
            key:'1',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.Feb', // 二月
            key:'2',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.March', // 三月
            key:'3',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.April', // 四月
            key:'4',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.May', // 五月
            key:'5',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.June', // 六月
            key:'6',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.July', // 七月
            key:'7',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.Aug', // 八月
            key:'8',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.Sep', // 九月
            key:'9',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.Oct', // 十月
            key:'10',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.Nov', // 十一月
            key:'11',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
        {
            name:'saleGoal.Dec', // 十二月
            key:'12',
            type:'inputNumber',
            allowClear:true,
            required: true,
            width:'300px',
            placeholder:'saleGoal.inputGoalSaleNumber',
            hideButton:true,
        },
    ]
}

DealerGoalQueryForm.formField.forEach(item=>{
    DealerGoalQueryForm.formData[item.key] = ''
})

AddDealerGoalForm.formField.forEach(item=>{
    AddDealerGoalForm.formData[item.key] = ''
})

SaleGoalQueryForm.formField.forEach(item=>{
    SaleGoalQueryForm.formData[item.key] = ''
})

AddSaleGoalForm.formField.forEach(item=>{
    AddSaleGoalForm.formData[item.key] = ''
})

AddSaleGoalForm2.formField.forEach(item=>{
    AddSaleGoalForm2.formData[item.key] = ''
})

export {
    DealerGoalQueryForm,
    AddDealerGoalForm,
    SaleGoalQueryForm,
    AddSaleGoalForm,
    AddSaleGoalForm2
}